import { observer } from 'mobx-react-lite'
import { ScheduleDelay } from 'shared/ui/Schedule/ui/ScheduleDelay'
import { useCampaignScheduleContext } from 'pages/campaigns/ui/CampaignSchedule/context/context'
import styles from './styles.module.scss'

type ILaterContentProps = {
  dropdownId: string
}

export const DelayContent = observer(({ dropdownId }: ILaterContentProps) => {
  const { scheduleDelayStore } = useCampaignScheduleContext()

  return (
    <div className={styles.wrap}>
      <ScheduleDelay store={scheduleDelayStore} dropdownId={dropdownId} />
    </div>
  )
})
